<div class="link-nav" *ngIf="menu">
  <div [ngClass]="menuItem.children ? 'header-menu-dropdown' : ''"  class="-link-items" *ngFor="let menuItem of menu">
    <a
      *ngIf="!menuItem.children && !menuItem.external && !menuItem.hidedesktop"
      [ngClass]="router.url.includes(menuItem.path) ? '-active' : ''"
      [routerLink]="'/' + menuItem.path"
      aria-label="MainNav">
        {{ menuItem.title }}
    </a>
    <a
      *ngIf="!menuItem.children && menuItem.external"
      [ngClass]="router.url.includes(menuItem.path) ? '-active' : ''"
      href="{{ menuItem.path }}"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="MainNav">
        {{ menuItem.title }}
    </a>
    <app-link *ngIf="menuItem.children" (click)="openParentMenu($event)"><span>{{ menuItem.title }}</span>
      <lucide-icon name="chevron-down" class="-custom-size-icon -desktop-icon"></lucide-icon>
      <span class="-icon-container">
        <lucide-icon name="chevron-right" class="-custom-size-icon -responsive-icon"></lucide-icon>
      </span>
    </app-link>
    <header-nav-dropdown
      *ngIf="menuItem.children"
      class="-menu"
      [title]="menuItem.title"
      [menuContent]="menuItem"
      [type]="menuItem.template ? menuItem.template : 'Solutions'"
      (closeNavEvent)="closeParentMenu($event)">
    </header-nav-dropdown>
  </div>
</div>
